import { render, staticRenderFns } from "./resourceInfo.vue?vue&type=template&id=196a19c0"
import script from "./resourceInfo.vue?vue&type=script&lang=js"
export * from "./resourceInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports